import { render, staticRenderFns } from "./_article.vue?vue&type=template&id=19fc007a&scoped=true&lang=pug&"
import script from "./_article.vue?vue&type=script&lang=coffee&"
export * from "./_article.vue?vue&type=script&lang=coffee&"
import style0 from "./_article.vue?vue&type=style&index=0&id=19fc007a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fc007a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlocksSimpleMarquee: require('/opt/build/repo/nuxt-app/components/blocks/simple-marquee.vue').default,BlocksSpacer: require('/opt/build/repo/nuxt-app/components/blocks/spacer.vue').default,BlocksCopy: require('/opt/build/repo/nuxt-app/components/blocks/copy.vue').default,ShareLinks: require('/opt/build/repo/library/components/globals/share-links.vue').default,BlocksProductCarousel: require('/opt/build/repo/nuxt-app/components/blocks/product-carousel.vue').default,BlocksArticleCarousel: require('/opt/build/repo/nuxt-app/components/blocks/article-carousel.vue').default,Btn: require('/opt/build/repo/nuxt-app/components/globals/btn/btn.vue').default,BlocksNewsletter: require('/opt/build/repo/nuxt-app/components/blocks/newsletter.vue').default})
